import script from "./ProductTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTableRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__